import Model from 'src/models/model'

// Necessary for services that need to be unit tested so that we can stub the inventory strategy.
export function getInventoryStrategy () {
  return Model.configuration.currentSite?.activeInventoryStrategy
}
